import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'eva-dropdown',
  template: `
    <div class="eva-3-filters-vertical -show-filters">
      <ul class="eva-3-dropdown">
        <ng-content></ng-content>
      </ul>
    </div>
  `,
  styleUrls: ['./eva-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EvaDropdownComponent {
  constructor() { }
}
